<template>
	<div id="main-navigation">
		<primary-drawer></primary-drawer>

		<profile-drawer></profile-drawer>

		<v-toolbar
			app
			flat
			dark
			:color="dark ? 'accent darken-4' : 'accent'"
			height="54"
			extended
			:extension-height="extensionHeight"
			class="main-navigation"
		>
			<v-toolbar-side-icon
				@click.stop="TOGGLE_PRIMARY_DRAWER"
				v-if="this.$vuetify.breakpoint.mdAndDown"
			></v-toolbar-side-icon>
			<img
				class="logo"
				v-if="currentTeam.photo_url"
				:src="currentTeam.photo_url"
				:alt="currentTeam.name"
			/>
			<v-toolbar-title v-else>{{currentTeam.name}}</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-toolbar-items>
				<v-btn flat href="/logout">Logout</v-btn>
			</v-toolbar-items>

			<main-title-bar slot="extension" class="main-navigation__title-bar"></main-title-bar>
		</v-toolbar>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ProfileDrawer from "@components/ProfileDrawer.vue";
import PrimaryDrawer from "@components/PrimaryDrawer.vue";
import MainTitleBar from "@components/MainTitleBar";

export default {
	data() {
		return {};
	},

	components: { ProfileDrawer, PrimaryDrawer, MainTitleBar },

	computed: {
		...mapGetters(["user", "currentTeam", "dark"]),

		extensionHeight() {
			let height = "74";

			if (this.$vuetify.breakpoint.smAndDown) {
				if (this.searchParams.show) {
					height = "100";
				} else {
					height = "50";
				}
			}

			return height;
		},

		searchParams() {
			return this.getMetaValue("search")
				? this.getMetaValue("search")
				: { show: false };
		}
	},

	methods: {
		...mapMutations(["SET_VALUE", "TOGGLE_PRIMARY_DRAWER"]),

		changeTitle(item) {
			this.page.title = item.title;
			this.page.icon = item.icon;
		},

		getMetaValue(key) {
			let matched = this.getObjectValue("matched", this.$route);
			for (let i = 0; i < matched.length; i++) {
				let value = this.getObjectValue(`meta.${key}`, matched[i]);
				if (value !== null) {
					return value;
				}
			}
			return null;
		}
	}
};
</script>
